import { FC } from 'react';

import { Progress } from '@beeline/design-system-react/extracted-styles';

import classes from './Loader.module.scss';

export const Loader: FC = () => {
  return (
    <div className={classes.container}>
      <Progress shape='circle' cycled />
    </div>
  );
};
